import {
  useGetFeatureFlagsQuery,
  type GetFeatureFlagsQuery,
} from '@/graphql/queries/getFeatureFlags.generated';

type FeatureFlags = NonNullable<GetFeatureFlagsQuery['getFeatureFlags']>;
type FeatureFlagKey = keyof Omit<FeatureFlags, '__typename'>;

export function useFeatureFlag(flag: FeatureFlagKey): boolean {
  const { data } = useGetFeatureFlagsQuery();
  return data?.getFeatureFlags?.[flag] ?? false;
}
